/* jshint esversion: 6 */
import React,  {useEffect, useState } from "react";
//import { withRouter } from 'react-router';
import { makeStyles, createStyles }   from '@material-ui/core/styles';
import Button         from '@material-ui/core/Button';
import TextField      from '@material-ui/core/TextField';
import MenuItem       from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import Grid           from '@material-ui/core/Grid'
import Typography     from '@material-ui/core/Typography';
import Toolbar        from '@material-ui/core/Toolbar';
import Resizer        from 'react-image-file-resizer';
import firebase       from 'firebase/compat/app';
import 'firebase/compat/auth';

/* 開発メモ
handleFollowUpReferenceButton() ⇒ 経過画像変更用参照ボタンを押したときに呼び出される。
 ⇒ handleFollowUpImageFileChange()が実行される。
handleFollowUpImageFileChange() 経過記録画像変更時の処理
FollowUp_Thumbnail_ImageDraw() 経過サムネイル画像を描画
FollowUpImageDraw() 経過画像描画
loadFollowUpImage(src) 経過記録画像読み込み処理
RegistFollowUpImage() 経過画像登録処理
 */

const useStyles = makeStyles((theme) => createStyles ({
  button: {
    margin: 2,
    //width: 150,
  },
  root: {
    height: 800,
  },
  image: {
    width:  64,
    height: 64,
  },
  img: {
    margin:    'auto',
    display:   'block',
    maxWidth:  '100%',
    maxHeight: '100%',
  },
}));

//経過画像一覧
let DataImageList = {
  list:[
    //{
    //  number:       "(数値)",     //画像番号
    //  source_url:   "(文字列)",   //取り込み元画像
    //  image_url:    "(文字列)",   //経過画像パス
    //  thum_url:     "(文字列)",   //経過サムネイル画像パス
    //  CreateTime:   "(日時)",     //作成時刻
    //  UpdateTime:   "(日時)",     //更新時刻
    //  ShootingTime: "(日時)",     //撮影時刻
    //  image_change: "(ブール値)", //経過登録画像の変更有無（true=変更あり、false=変更なし）
    //}
  ],
  UploadList:[
    //{
    //  image_url:    "(文字列)",   //経過画像パス
    //  thum_url:     "(文字列)",   //経過サムネイル画像パス
    //  CreateTime:   "(日時)",     //作成時刻
    //  UpdateTime:   "(日時)",     //更新時刻
    //  ShootingTime: "(日時)",     //撮影時刻
    //}
  ]
}

//画像リサイズ用定数
const resizer = {
  maxWidth:           1920,    //変換後画像の最大横幅
  maxHeight:          1920,    //変換後画像の最大縦幅
  maxThumbnailWidth:  320,     //変換後サムネイル画像の最大横幅
  maxThumbnailHeight: 320,     //変換後サムネイル画像の最大縦幅
  compressFormat:     "JPEG",  //圧縮フォーマット（JPEG, PNG or WEBP）
  quality:            80,      //画質（0 ~ 100 圧縮しない場合は100をセットする。）
  outputType:         "bolb" //出力タイプ（base64, bolb, file）
}

let First_FollowUp_ = ''

export default function Interview(props) {
  const classes = useStyles()
  const [ uid,                     setUid                     ] = useState(props.uid)               //ログインユーザーのuid
  const [ FamilyID,                setFamilyID                ] = useState(props.FamilyID)          //診療情報登録対象の家族ID
  const [ MemberID,                setMemberID                ] = useState(props.MemberID)          //診療情報登録対象のメンバーID
  const [ DisplayName,             setDisplayName             ] = useState(props.DisplayName)       //診療情報登録対象の表示名
  const [ member_url,              setmember_url              ] = useState(props.member_url)        //診療情報登録対象のアイコン画像パス
  const [ MedicalRecord_ID,        setMedicalRecord_ID        ] = useState(props.MedicalRecord_ID)  //診療情報のレコードID
  const [ Interview_state,         setInterview_state         ] = useState(props.Interview_state)   //問診票の取扱状態（'New'=新規作成, 'View'=表示, Edit'=編集）
  const [ modalShow,               setmodalShow               ] = useState(false)      //modalの表示状態
  const [ isLogin,                 setisLogin                 ] = useState(false)      //ログイン状態
  const [ EditShow,                setEditShow                ] = useState('none')     //問診票新規＋編集共通表示
  const [ NewOnlyShow,             setNewOnlyShow             ] = useState('none')     //新規問診票登録画面の表示設定 (block=ブロック表示、none=非表示)
  const [ EditOnlyShow,            setEditOnlyShow            ] = useState('none')     //問診票編集画面の表示設定 (block=ブロック表示、none=非表示)
  const [ ViewShow,                setViewShow                ] = useState('none')     //問診票表示画面の表示設定 (block=ブロック表示、none=非表示)
  const [ CreateTime,              setCreateTime              ] = useState(new Date()) //診療情報作成日時
  const [ UpdateTime,              setUpdateTime              ] = useState(new Date()) //診療情報更新日時
  const [ ConsultationTime,        setConsultationTime        ] = useState(new Date()) //診療の受診日時（予定日を含む。2022年9月以降の必須項目。情報が無い場合は、診療情報作成日時を表示する）
  const [ MedicalSpecialty,        setMedicalSpecialty        ] = useState('')         //診療科目
  const [ Title,                   setTitle                   ] = useState('')         //診療情報一覧に表示するタイトル
  const [ HospitalName,            setHospitalName            ] = useState('')         //病院名
  const [ Diagnosis,               setDiagnosis               ] = useState('')         //診断結果
  const [ Reason_for_Consultation, setReason_for_Consultation ] = useState('')         //受診理由（2021/08/13 追加 高橋）
  const [ Fever_Symptoms,          setFever_Symptoms          ] = useState(false)      //発熱症状の有無
  const [ Fever_Since,             setFever_Since             ] = useState('')         //発熱いつから 例：2021-08-17 or ''
  const [ Fever_Degrees,           setFever_Degrees           ] = useState(0)          //発熱時の体温
  const [ RunnyNose_Symptoms,      setRunnyNose_Symptoms      ] = useState(false)      //鼻水の有無
  const [ RunnyNose_Since,         setRunnyNose_Since         ] = useState('')         //鼻水いつから
  const [ RunnyNose_Color,         setRunnyNose_Color         ] = useState('')         //鼻水の色
  const [ Cough_Symptoms,          setCough_Symptoms          ] = useState(false)      //咳の有無
  const [ Cough_Since,             setCough_Since             ] = useState('')         //咳いつから
  const [ Cough_Type,              setCough_Type              ] = useState('')         //咳の種類
  const [ Headache_Symptoms,       setHeadache_Symptoms       ] = useState(false)      //頭痛の有無
  const [ Headache_Since,          setHeadache_Since          ] = useState('')         //頭痛いつから
  const [ Phlegm_Symptoms,         setPhlegm_Symptoms         ] = useState(false)      //痰の有無
  const [ Phlegm_Since,            setPhlegm_Since            ] = useState('')         //痰いつから
  const [ Wheeze_Symptoms,         setWheeze_Symptoms         ] = useState(false)      //喘鳴の有無
  const [ Wheeze_Since,            setWheeze_Since            ] = useState('')         //喘鳴いつから
  const [ Vomit_Symptoms,          setVomit_Symptoms          ] = useState(false)      //嘔吐の有無
  const [ Vomit_Since,             setVomit_Since             ] = useState('')         //嘔吐いつから
  const [ Vomit_times_per_day,     setVomit_times_per_day     ] = useState(0)          //1日の嘔吐回数
  const [ Diarrhea_Symptoms,       setDiarrhea_Symptoms       ] = useState(false)      //下痢の有無
  const [ Diarrhea_Since,          setDiarrhea_Since          ] = useState('')         //下痢いつから
  const [ Diarrhea_times_per_day,  setDiarrhea_times_per_day  ] = useState(0)          //1日の下痢回数
  const [ Stommachache_Symptoms,   setStommachache_Symptoms   ] = useState(false)      //腹痛の有無
  const [ Stommachache_Since,      setStommachache_Since      ] = useState('')         //腹痛いつから
  const [ Eruption_Symptoms,       setEruption_Symptoms       ] = useState(false)      //発疹の有無
  const [ Eruption_Since,          setEruption_Since          ] = useState('')         //発疹いつから
  const [ Spasm_Symptoms,          setSpasm_Symptoms          ] = useState(false)      //けいれんの有無
  const [ Spasm_Since,             setSpasm_Since             ] = useState('')         //けいれん いつから
  const [ Note,                    setNote                    ] = useState('')         //フリーメモ
  const [ First_FollowUp,          setFirst_FollowUp          ] = useState('')         //初回経過情報参照先のドキュメントパス
  const [ BodyTemperature,         setBodyTemperature         ] = useState('')         //体温(経過登録用)
  const [ Appetite,                setAppetite                ] = useState('')         //食欲(経過登録用)
  const [ Moisture,                setMoisture                ] = useState('')         //水分(経過登録用)
  const [ Mood,                    setMood                    ] = useState('')         //機嫌(経過登録用)
  const [ View_Appetite,           setView_Appetite           ] = useState('')         //食欲(初回経過情報表示用)
  const [ View_Moisture,           setView_Moisture           ] = useState('')         //水分(初回経過情報表示用)
  const [ View_Mood,               setView_Mood               ] = useState('')         //機嫌(初回経過情報表示用)
  const [ FollowUpNote,            setFollowUpNote            ] = useState('')         //メモ(経過登録用)
  const [ FollowUp_image_url,      setFollowUp_image_url      ] = useState('')         //経過登録用画像
  const [ FollowUp_thum_url,       setFollowUp_thum_url       ] = useState('')         //経過登録用サムネイル画像
  const [ FollowUp_image_change,   setFollowUp_image_change   ] = useState(false)      //経過登録画像の変更有無（true=変更あり、false=変更なし）
  const [ FollowUpImageBox_width,  setFollowUpImageBox_width  ] = useState(0)          //経過画像表示領域の横幅（初期値）
  const [ FollowUpImageBox_height, setFollowUpImageBox_height ] = useState(0)          //経過画像表示領域の高さ（初期値）
  const [ FollowUp_CreateTime,     setFollowUp_CreateTime     ] = useState(new Date()) //経過情報が初めて記録された時刻
  const [ FollowUp_UpdateTIme,     setFollowUp_UpdateTIme     ] = useState(new Date()) //経過情報更新時刻
  const [ FollowUpTime,            setFollowUpTime            ] = useState(new Date()) //経過情報を設定した時刻
  const [ data_image_list,         setdata_image_list         ] = useState([])         //経過画像格納用リスト
  
  //DataImageList.list = []
  //DataImageList.UploadList = []
  // console.log("data_image_list")
  // console.dir(data_image_list)

  // モーダル再表示時に画像データを初期化する。
  if (data_image_list.length === 0){
    DataImageList.list = []
    DataImageList.UploadList = []
  }

  //経過画像リスト確認用
  const FollowUpImgView = []

  //受診日
  const handleEditConsultationTime = (e) =>{
    setConsultationTime(new Date(e.target.value))
  }

  //診断結果
  const handleEditDiagnosis = (e) => {
    setDiagnosis(e.target.value)
  }

  //受診病院名
  const handleEditHospitalName = (e) => {
    setHospitalName(e.target.value)
  }

  //診療科目
  const handleEditMedicalSpecialty = (e) => {
    setMedicalSpecialty(e.target.value)
  }

  //受診理由
  const Edit_Reason_for_Consultation = (e) => {
    setReason_for_Consultation(e.target.value)
  }

  //発熱いつから
  const handleFeverSinceChange = (e) => {
    setFever_Since(e.target.value)
    if(e.target.value !== '' || Fever_Degrees !== 0){
      setFever_Symptoms(true)  //発症時期が選択されているか、体温の入力がある場合は、「発熱」にチェックを入れる。
    } else {
      setFever_Symptoms(false) //発症時期が選択されていないかつ、体温の入力が無い場合は、「発熱」のチェックを外す。
    }
  }

  //発熱時の体温
  const handleFeverDegreesChange = (e) => {
    if(e.target.value !== '0.0'){
      setFever_Degrees(Number(e.target.value)) //体温は数値型で格納する。
      if(Interview_state === 'New'){ //問診票の新規登録時の体温入力は、経過登録にも使用する。
        setBodyTemperature(Number(e.target.value))
      }
    } else {
      setFever_Degrees(0) //体温の登録が無い場合は、0を入れる。
      if(Interview_state === 'New'){ //問診票の新規登録時の体温入力は、経過登録にも使用する。
        setBodyTemperature(0)
      }
    }
    if(e.target.value !== '0.0' || Fever_Since !== ''){
      setFever_Symptoms(true)  //発症時期が選択されているか、体温の入力がある場合は、「発熱」にチェックを入れる。
    } else {
      setFever_Symptoms(false) //発症時期が選択されていないかつ、体温の入力が無い場合は、「発熱」のチェックを外す。
    }
  }

  //鼻水いつから
  const handleRunnyNoseSinceChange = (e) => {
    setRunnyNose_Since(e.target.value)
    if(e.target.value !== '' || RunnyNose_Color !== ''){
      setRunnyNose_Symptoms(true)  //発症時期が選択されているか、鼻水の色が選択されている場合は、「鼻水」にチェックを入れる。
    } else {
      setRunnyNose_Symptoms(false) //発症時期が選択されていないかつ、鼻水の色が選択されていない場合は、「鼻水」のチェックを外す。
    }
  }

  //鼻水の色
  const handleRunnyNoseColorChange = (e) => {
    setRunnyNose_Color(e.target.value)
    if(e.target.value !== '' || RunnyNose_Since !== ''){
      setRunnyNose_Symptoms(true)  //発症時期が選択されているか、鼻水の色が選択されている場合は、「鼻水」にチェックを入れる。
    } else {
      setRunnyNose_Symptoms(false) //発症時期が選択されていないかつ、鼻水の色が選択されていない場合は、「鼻水」のチェックを外す。
    }
  }

  //咳いつから
  const handleCoughSinceChange = (e) => {
    setCough_Since(e.target.value)
    if(e.target.value !== '' || Cough_Type !== ''){
      setCough_Symptoms(true)  //発症時期が選択されているか、咳の種類が選択されている場合は、「咳」にチェックを入れる。
    } else {
      setCough_Symptoms(false) //発症時期が選択されていないかつ、咳の種類が選択されていない場合は、「咳」のチェックを外す。
    }
  }

  //咳の種類
  const handleCoughTypeChange = (e) => {
    setCough_Type(e.target.value)
    if(e.target.value !== '' || Cough_Since !== ''){
      setCough_Symptoms(true)  //発症時期が選択されているか、咳の種類が選択されている場合は、「咳」にチェックを入れる。
    } else {
      setCough_Symptoms(false) //発症時期が選択されていないかつ、咳の種類が選択されていない場合は、「咳」のチェックを外す。
    }
  }

  //頭痛いつから
  const handleHeadacheSinceChange = (e) => {
    setHeadache_Since(e.target.value)
    if(e.target.value !== ''){
      setHeadache_Symptoms(true)  //発症時期が選択されている場合は、「頭痛」にチェックを入れる。
    } else {
      setHeadache_Symptoms(false) //発症時期が選択されていない場合は、「頭痛」のチェックを外す。
    }
  }

  //痰いつから
  const handlePhlegmSinceChange = (e) => {
    setPhlegm_Since(e.target.value)
    if(e.target.value !== ''){
      setPhlegm_Symptoms(true)   //発症時期が選択されている場合は、「痰」にチェックを入れる。
    } else {
      setPhlegm_Symptoms(false)  //発症時期が選択されていない場合は、「痰」のチェックを外す。
    }
  }

  //喘鳴（ゼーゼーとした息）いつから
  const handleWheezeSinceChange = (e) => {
    setWheeze_Since(e.target.value)
    if(e.target.value !== ''){
      setWheeze_Symptoms(true)  //発症時期が選択されている場合は、「喘鳴」にチェックを入れる。
    } else {
      setWheeze_Symptoms(false) //発症時期が選択されていない場合は、「喘鳴」のチェックを外す。
    }
  }

  //嘔吐いつから
  const handleVomitSinceChange = (e) => {
    setVomit_Since(e.target.value)
    if(e.target.value !== '' || Vomit_times_per_day !== 0){
      setVomit_Symptoms(true)  //発症時期が選択されているか、嘔吐の回数が選択されている場合は、「嘔吐」にチェックを入れる。
    } else {
      setVomit_Symptoms(false) //発症時期が選択されていないかつ、嘔吐の回数が選択されていない場合は、「嘔吐」のチェックを外す。
    }
  }

  //嘔吐の回数
  const handleVomitTimesChange = (e) => {
    if(e.target.value !== '0'){
      setVomit_times_per_day(Number(e.target.value)) //1回以上の場合は回数を記録する。
    } else {
      setVomit_times_per_day(0)
    }
    if(e.target.value !== '0' || Vomit_Since !== ''){
      setVomit_Symptoms(true)  //発症時期が選択されているか、嘔吐の回数が選択されている場合は、「嘔吐」にチェックを入れる。
    } else {
      setVomit_Symptoms(false) //発症時期が選択されていないかつ、嘔吐の回数が選択されていない場合は、「嘔吐」のチェックを外す。
    }
  }

  //下痢いつから
  const handleDiarrheaSinceChange = (e) => {
    setDiarrhea_Since(e.target.value)
    if(e.target.value !== '' || Diarrhea_times_per_day !== 0){
      setDiarrhea_Symptoms(true)  //発症時期が選択されているか、下痢の回数が選択されている場合は、「下痢」にチェックを入れる。
    } else {
      setDiarrhea_Symptoms(false) //発症時期が選択されていないかつ、下痢の回数が選択されていない場合は、「下痢」のチェックを外す。
    }
  }

  //下痢の回数
  const handleDiarrheaTimesChange = (e) => {
    if(e.target.value !== '0'){
      setDiarrhea_times_per_day(Number(e.target.value)) //1回以上の場合は回数を記録する。
    } else {
      setDiarrhea_times_per_day(0)
    }
    if(e.target.value !== '0' || Diarrhea_Since !== ''){
      setDiarrhea_Symptoms(true)  //発症時期が選択されているか、下痢の回数が選択されている場合は、「下痢」にチェックを入れる。
    } else {
      setDiarrhea_Symptoms(false) //発症時期が選択されていないかつ、下痢の回数が選択されていない場合は、「下痢」のチェックを外す。
    }
  }

  //腹痛いつから
  const handleStommachacheSinceChange = (e) => {
    setStommachache_Since(e.target.value)
    if(e.target.value !== ''){
      setStommachache_Symptoms(true)  //発症時期が選択されている場合は、「腹痛」にチェックを入れる。
    } else {
      setStommachache_Symptoms(false) //発症時期が選択されていない場合は、「腹痛」のチェックを外す。
    }
  }

  //発疹いつから
  const handleEruptionSinceChange = (e) => {
    setEruption_Since(e.target.value)
    if(e.target.value !== ''){
      setEruption_Symptoms(true)  //発症時期が選択されている場合は、「発疹」にチェックを入れる。
    } else {
      setEruption_Symptoms(false) //発症時期が選択されていない場合は、「発疹」のチェックを外す。
    }
  }

  //けいれん いつから
  const handleSpasmSinceChange = (e) => {
    setSpasm_Since(e.target.value)
    if(e.target.value !== ''){
      setSpasm_Symptoms(true)  //発症時期が選択されている場合は、「けいれん」にチェックを入れる。
    } else {
      setSpasm_Symptoms(false) //発症時期が選択されていない場合は、「けいれん」のチェックを外す。
    }
  }

  //食欲変更時の処理
  const handleAppetiteChange = (e) => {
    setAppetite(e.target.value)
  }

  //水分変更時の処理
  const handleMoistureChange = (e) => {
    setMoisture(e.target.value)
  }

  //機嫌変更時の処理
  const handleMoodChange = (e) => {
    setMood(e.target.value)
  }

  //フリーメモ変更時の処理
  const handleNote = (e) => {
    setNote(e.target.value)
    setFollowUpNote(e.target.value)
  }

  //前のページに戻る（「戻る」ボタン）
  const handleGoBack = () => {
    if(typeof props.handleModalClose == 'function'){
      props.handleModalClose() // PersonalHome,SymptomCardよりロードされた場合は、モーダルを閉じる
    }
  }

  //モーダルを非表示状態に切り替える
  const handleModalClose = () => {
    console.log("handleModalClose()")
    DataImageList.list = []
    setdata_image_list(DataImageList.list.slice(0, 0))
    if(typeof props.handleModalClose == 'function'){
      props.handleModalClose() // 症状カード画面のモーダルを閉じる
    }
  }

  //モーダルを非表示状態に切り替え、症状カード画面で再読み込みする
  const handleReloadModalClose = async () => {
    console.log("handleReloadModalClose()")
    DataImageList.list = []
    setdata_image_list(DataImageList.list.slice(0, 0))
    if(typeof props.handleReloadModalClose == 'function'){
      await props.handleReloadModalClose() // 個人ホーム画面または、症状カード画面のモーダルを閉じ、画面内データを再読み込みする。
    }
  }

  //問診票登録（「登録」ボタンを押した際のアクション）
  const handleRegist = async () => {
    // 問診票登録時の医療機関名チェックを廃止（問診票登録時に医療機関名の登録を行わない為）（2021/08/13 高橋）
    //if ( HospitalName === '' ){
    //  alert("受診する医療機関名を入れてください")
    //  return
    //}

    //作成時刻と更新時刻を登録時に更新する。
    setUpdateTime(new Date()) //診療情報更新時間
    setCreateTime(new Date()) //診療情報作成日時

    let MedicalRecord_ID_ = ''
    let CreateTime_ = new Date()
    let UpdateTime_ = new Date()

    //作成時刻と更新時刻を登録時に更新する。
    setUpdateTime(UpdateTime_) //診療情報更新時間
    setCreateTime(CreateTime_) //診療情報作成日時

    //データベースに問診票の登録を実施する。
    MedicalRecord_ID_ = await RegistInterview(CreateTime_, UpdateTime_)

    var create_time = CreateTime_;
    var Doc_ID = create_time.getFullYear() + ('0' + (create_time.getMonth()+1)).slice(-2) + ('0' + create_time.getDate()).slice(-2) + 
                 ('0' + create_time.getHours()).slice(-2) + ('0' + create_time.getMinutes()).slice(-2) + ('0' + create_time.getSeconds()).slice(-2);

    //経過画像登録処理
    await RegistFollowUpImage(Doc_ID, MedicalRecord_ID_)

    //データベースに経過情報の登録を実施する。
    await RegistFollowUp(MedicalRecord_ID_, CreateTime_, UpdateTime_)

    //個人ホーム画面の問診票登録モーダル表示を閉じ、画面内データの再読み込みを行う。
    handleReloadModalClose()
  }

  //問診票更新（「保存」ボタンを押した際のアクション）
  const handleUpdate = async() => {
    //更新時刻を更新時に更新する。
    setUpdateTime(new Date())          //診療情報更新時間
    setFollowUp_UpdateTIme(new Date()) //経過情報更新時間

    var create_time = CreateTime;
    var Doc_ID = create_time.getFullYear() + ('0' + (create_time.getMonth()+1)).slice(-2) + ('0' + create_time.getDate()).slice(-2) + 
                 ('0' + create_time.getHours()).slice(-2) + ('0' + create_time.getMinutes()).slice(-2) + ('0' + create_time.getSeconds()).slice(-2);
    let MedicalRecord_ID_ = MedicalRecord_ID
    //経過画像更新処理
    await RegistFollowUpImage(Doc_ID, MedicalRecord_ID_)

    if(First_FollowUp === ''){
      //初回経過情報が未登録の場合は登録を行う。
      //データベースに経過情報の登録を実施する。
      await RegistFollowUp()
    } else {
      //初回経過情報が登録済みの場合は更新を行う。
      await UpdateFollowUp()
    }

    //データベースの内容を更新する。
    await UpdateInterView()

    //症状カード画面の問診票モーダル表示を閉じ、画面内データの再読み込みを行う。
    handleReloadModalClose()
  }

  //問診票編集画面へ移動
  // const handleEdit = async() => {
  //   setInterview_state('Edit') //問診票編集モード
  //   setEditShow('block')       //問診票 新規登録＋編集共通表示【表示】
  //   setNewOnlyShow('none')     //問診票 新規登録画面　　　　　【非表示】
  //   setEditOnlyShow('block')   //問診票 編集画面　　　　　　　【表示】
  //   setViewShow('none')  //問診票 表示画面　　　　　　　【非表示】
  //   ReadInterview()       //データベースから登録済みの問診票データを読み出す。
  //   if(FollowUp_image_url !== ''){
  //     //初回経過画像が登録されている場合は描画する。
  //     setFollowUpImageBox_width(128)  // 経過画像表示領域の横幅を128pxで設定する。
  //     setFollowUpImageBox_height(128) // 経過画像表示領域の高さを128pxで設定する。
  //   }
  // }

  //問診票表示画面へ移動
  // const handleView = async() => {
  //   setInterview_state('View')  //問診票編集モード
  //   setEditShow('none')       //問診票 新規登録＋編集共通表示【非表示】
  //   setNewOnlyShow('none')    //問診票 新規登録画面　　　　　【非表示】
  //   setEditOnlyShow('none')   //問診票 編集画面　　　　　　　【非表示】
  //   setViewShow('block')      //問診票 表示画面　　　　　　　【表示】
  //   setFollowUp_image_url('') //経過画像表示をリセットする。
  //   await ReadInterview()     //データベースから登録済みの問診票データを読み出す。
  //   if(First_FollowUp !== ''){
  //     //初回経過情報が登録されている場合は読み出す。
  //     await ReadFollowUp()    //データベースから登録済みの初回経過情報を読み出す。
  //   }
  // }

  //「いつから」を日付（yyyy-mm-dd）に変換する。
  const getSince = (Since, CreateTime) => {
    if (Object.prototype.toString.call(Since) === '[object String]') {
      switch(Since) {
        case '':
          Since = ''
          break
        
        case '今日から':
          Since = CreateTime
          Since.setDate(Since.getDate())
          Since = Since.getFullYear() + '-' + ('0' + (Since.getMonth() + 1)).slice(-2) + '-' + ('0' + Since.getDate()).slice(-2)
          break
        
        case '昨日から':
          Since = CreateTime
          Since.setDate(Since.getDate() - 1)
          Since = Since.getFullYear() + '-' + ('0' + (Since.getMonth() + 1)).slice(-2) + '-' + ('0' + Since.getDate()).slice(-2)
          break

        case '２、３日前から':
          Since = CreateTime
          Since.setDate(Since.getDate() - 2)
          Since = Since.getFullYear() + '-' + ('0' + (Since.getMonth() + 1)).slice(-2) + '-' + ('0' + Since.getDate()).slice(-2)
          break

        case '４、５日前から':
          Since = CreateTime
          Since.setDate(Since.getDate() - 4)
          Since = Since.getFullYear() + '-' + ('0' + (Since.getMonth() + 1)).slice(-2) + '-' + ('0' + Since.getDate()).slice(-2)
          break

        case '１週間前から':
          Since = CreateTime
          Since.setDate(Since.getDate() - 7)
          Since = Since.getFullYear() + '-' + ('0' + (Since.getMonth() + 1)).slice(-2) + '-' + ('0' + Since.getDate()).slice(-2)
          break

        case '２週間前から':
          Since = CreateTime
          Since.setDate(Since.getDate() - 14)
          Since = Since.getFullYear() + '-' + ('0' + (Since.getMonth() + 1)).slice(-2) + '-' + ('0' + Since.getDate()).slice(-2)
          break

        case '１カ月前から':
          Since = CreateTime
          Since.setMonth(Since.getMonth() - 1)
          Since = Since.getFullYear() + '-' + ('0' + (Since.getMonth() + 1)).slice(-2) + '-' + ('0' + Since.getDate()).slice(-2)
          break

        case 'もっと前から':
          Since = CreateTime
          Since.setMonth(Since.getMonth() - 2)
          Since = Since.getFullYear() + '-' + ('0' + (Since.getMonth() + 1)).slice(-2) + '-' + ('0' + Since.getDate()).slice(-2)
          break

        default:
          Since = ''
          break
      }
      
    } else if (Object.prototype.toString.call(Since) === '[object Object]') {
      Since = Since.toDate()
      Since = Since.getFullYear() + '-' + ('0' + (Since.getMonth() + 1)).slice(-2) + '-' + ('0' + Since.getDate()).slice(-2)

    } else if (Object.prototype.toString.call(Since) === '[object Null]') {
      Since = ''
    }
    //console.log('Since: ' + Since)
    return Since
  }

  //「いつから」の部分をDate型で取得する。
  const getSinceDate = (SinceString) => {
    if (SinceString !== ''){
      //console.log('Date: ' + new Date(SinceString.replace(/-/g,"/") + ' 00:00:00')) //日付の変換の際、iOS Safari対策で「-」を「/」に変換
      return new Date(SinceString.replace(/-/g,"/") + ' 00:00:00') //日付の変換の際、iOS Safari対策で「-」を「/」に変換
    } else {
      return ''
    }
  }

  //データベースに登録されている問診票の情報を読み込む
  const ReadInterview = async() => {
    console.log("ReadInterview() start!!")
    var db = firebase.firestore()

    await db.collection("MedicalRecords").doc(MedicalRecord_ID).get().then((result)=>{
      var data = result.data()
      //console.dir(data)
      //console.log('ConsultationTime:' + (("ConsultationTime"        in data) ? data.ConsultationTime.toDate() : ("CreateTime" in data) ? data.CreateTime.toDate() : new Date()))
      setFamilyID                (("FamilyID"                in data) ? data.FamilyID                  : '')         //診療情報登録対象の家族ID
      setMemberID                (("FamilyID"                in data) ? data.MemberID                  : '')         //診療情報登録対象のメンバーID
      setCreateTime              (("CreateTime"              in data) ? data.CreateTime.toDate()       : new Date()) //診療情報作成日時
      setUpdateTime              (("UpdateTime"              in data) ? data.UpdateTime.toDate()       : new Date()) //診療情報更新日時
      setConsultationTime        (("ConsultationTime"        in data) ? data.ConsultationTime.toDate() : ("CreateTime" in data) ? data.CreateTime.toDate() : new Date()) //受診日 無い場合は問診票登録日 そのデータもない場合は問診票作成日時
      setMedicalSpecialty        (("MedicalSpecialty"        in data) ? data.MedicalSpecialty          : '')         //診療科目
      setTitle                   (("Title"                   in data) ? data.Title                     : '')         //診療情報一覧に表示するタイトル
      setHospitalName            (("HospitalName"            in data) ? data.HospitalName              : '')         //病院名
      setDiagnosis               (("Diagnosis"               in data) ? data.Diagnosis                 : '')         //診断結果
      setReason_for_Consultation (("Reason_for_Consultation" in data) ? data.Reason_for_Consultation   : '')         //受診理由
      setFirst_FollowUp          (("First_FollowUp"          in data) ? data.First_FollowUp.path       : '')         //初回経過情報参照先のドキュメントパス
      First_FollowUp_           = (("First_FollowUp"          in data) ? data.First_FollowUp.path       : '')         //初回経過情報参照先のドキュメントパス

      if ("InterviewSheet" in data) {
        //let Fever_Since     = ("Fever_Since"            in data.InterviewSheet) ? data.CreateTime           : null
        let Fever_Since        = ("Fever_Since"        in data.InterviewSheet) ? data.InterviewSheet.Fever_Since        : null
        let RunnyNose_Since    = ("RunnyNose_Since"    in data.InterviewSheet) ? data.InterviewSheet.RunnyNose_Since    : null
        let Cough_Since        = ("Cough_Since"        in data.InterviewSheet) ? data.InterviewSheet.Cough_Since        : null
        let Headache_Since     = ("Headache_Since"     in data.InterviewSheet) ? data.InterviewSheet.Headache_Since     : null
        let Phlegm_Since       = ("Phlegm_Since"       in data.InterviewSheet) ? data.InterviewSheet.Phlegm_Since       : null
        let Wheeze_Since       = ("Wheeze_Since"       in data.InterviewSheet) ? data.InterviewSheet.Wheeze_Since       : null
        let Vomit_Since        = ("Vomit_Since"        in data.InterviewSheet) ? data.InterviewSheet.Vomit_Since        : null
        let Diarrhea_Since     = ("Diarrhea_Since"     in data.InterviewSheet) ? data.InterviewSheet.Diarrhea_Since     : null
        let Stommachache_Since = ("Stommachache_Since" in data.InterviewSheet) ? data.InterviewSheet.Stommachache_Since : null
        let Eruption_Since     = ("Eruption_Since"     in data.InterviewSheet) ? data.InterviewSheet.Eruption_Since     : null
        let Spasm_Since        = ("Spasm_Since"        in data.InterviewSheet) ? data.InterviewSheet.Spasm_Since        : null
        //console.log('Fever_Since: '     + Object.prototype.toString.call(Fever_Since)    ) // [object String] or [object Object] or [object Null]
        //console.log('RunnyNose_Since: ' + Object.prototype.toString.call(RunnyNose_Since)) // [object String] or [object Object] or [object Null]
        //console.log('Cough_Since: '     + Object.prototype.toString.call(Cough_Since)    ) // [object String] or [object Object] or [object Null]
        //console.log('String: '          + Object.prototype.toString.call(String())       ) // [object String]
        //console.log('Object: '          + Object.prototype.toString.call(new Object())   ) // [object Object]
        //console.log('Date: '            + Object.prototype.toString.call(new Date())     ) // [object Date]
        //console.log('null: '            + Object.prototype.toString.call(null)           ) // [object Null]
        Fever_Since        = getSince(Fever_Since,        data.CreateTime.toDate())
        RunnyNose_Since    = getSince(RunnyNose_Since,    data.CreateTime.toDate())
        Cough_Since        = getSince(Cough_Since,        data.CreateTime.toDate())
        Headache_Since     = getSince(Headache_Since,     data.CreateTime.toDate())
        Phlegm_Since       = getSince(Phlegm_Since,       data.CreateTime.toDate())
        Wheeze_Since       = getSince(Wheeze_Since,       data.CreateTime.toDate())
        Vomit_Since        = getSince(Vomit_Since,        data.CreateTime.toDate())
        Diarrhea_Since     = getSince(Diarrhea_Since,     data.CreateTime.toDate())
        Stommachache_Since = getSince(Stommachache_Since, data.CreateTime.toDate())
        Eruption_Since     = getSince(Eruption_Since,     data.CreateTime.toDate())
        Spasm_Since        = getSince(Spasm_Since,        data.CreateTime.toDate())

        setFever_Symptoms         (("Fever_Symptoms"         in data.InterviewSheet) ? data.InterviewSheet.Fever_Symptoms         : false ) //発熱症状の有無
        setFever_Since            (Fever_Since                                                                                            ) //発熱いつから
        setFever_Degrees          (("Fever_Degrees"          in data.InterviewSheet) ? data.InterviewSheet.Fever_Degrees          : 0     ) //発熱時の体温
        setRunnyNose_Symptoms     (("RunnyNose_Symptoms"     in data.InterviewSheet) ? data.InterviewSheet.RunnyNose_Symptoms     : false ) //鼻水の有無
        setRunnyNose_Since        (RunnyNose_Since                                                                                        ) //鼻水いつから
        setRunnyNose_Color        (("RunnyNose_Color"        in data.InterviewSheet) ? data.InterviewSheet.RunnyNose_Color        : 0     ) //鼻水の色
        setCough_Symptoms         (("Cough_Symptoms"         in data.InterviewSheet) ? data.InterviewSheet.Cough_Symptoms         : false ) //咳の有無
        setCough_Since            (Cough_Since                                                                                            ) //咳いつから
        setCough_Type             (("Cough_Type"             in data.InterviewSheet) ? data.InterviewSheet.Cough_Type             : 0     ) //咳の種類
        setHeadache_Symptoms      (("Headache_Symptoms"      in data.InterviewSheet) ? data.InterviewSheet.Headache_Symptoms      : false ) //頭痛の有無
        setHeadache_Since         (Headache_Since                                                                                         ) //頭痛いつから
        setPhlegm_Symptoms        (("Phlegm_Symptoms"        in data.InterviewSheet) ? data.InterviewSheet.Phlegm_Symptoms        : false ) //痰の有無
        setPhlegm_Since           (Phlegm_Since                                                                                           ) //痰いつから
        setWheeze_Symptoms        (("Wheeze_Symptoms"        in data.InterviewSheet) ? data.InterviewSheet.Wheeze_Symptoms        : false ) //喘鳴（呼吸音異常）の有無
        setWheeze_Since           (Wheeze_Since                                                                                           ) //喘鳴（呼吸音異常）いつから
        setVomit_Symptoms         (("Vomit_Symptoms"         in data.InterviewSheet) ? data.InterviewSheet.Vomit_Symptoms         : false ) //嘔吐の有無
        setVomit_Since            (Vomit_Since                                                                                            ) //嘔吐いつから
        setVomit_times_per_day    (("Vomit_times_per_day"    in data.InterviewSheet) ? data.InterviewSheet.Vomit_times_per_day    : 0     ) //1日の嘔吐回数
        setDiarrhea_Symptoms      (("Diarrhea_Symptoms"      in data.InterviewSheet) ? data.InterviewSheet.Diarrhea_Symptoms      : false ) //下痢の有無
        setDiarrhea_Since         (Diarrhea_Since                                                                                         ) //下痢いつから
        setDiarrhea_times_per_day (("Diarrhea_times_per_day" in data.InterviewSheet) ? data.InterviewSheet.Diarrhea_times_per_day : 0     ) //1日の下痢回数
        setStommachache_Symptoms  (("Stommachache_Symptoms"  in data.InterviewSheet) ? data.InterviewSheet.Stommachache_Symptoms  : false ) //腹痛の有無
        setStommachache_Since     (Stommachache_Since                                                                                     ) //腹痛いつから
        setEruption_Symptoms      (("Eruption_Symptoms"      in data.InterviewSheet) ? data.InterviewSheet.Eruption_Symptoms      : false ) //発疹の有無
        setEruption_Since         (Eruption_Since                                                                                         ) //発疹いつから
        setSpasm_Symptoms         (("Spasm_Symptoms"         in data.InterviewSheet) ? data.InterviewSheet.Spasm_Symptoms         : false ) //けいれんの有無
        setSpasm_Since            (Spasm_Since                                                                                            ) //けいれん いつから
        setNote                   (("Note"                   in data.InterviewSheet) ? data.InterviewSheet.Note                   : ''    ) //フリーメモ
      }
    }).then(()=>{
      console.log("ReadInterview() Finish!!")
    })
  }

  //データベースに登録されている、初回経過情報を読み出す。
  const ReadFollowUp = async() => {
    console.log("ReadFollowUp() start!!")
    var db = firebase.firestore()

    // await db.doc(First_FollowUp).get().then(async(result)=>{
    await db.doc(First_FollowUp_).get().then(async(result)=>{
      var data = result.data()
      var View_Appetite       = ("Appetite"  in data) ? data.Appetite  : '' //食欲の値が無い場合は空白にする。
      var View_Moisture       = ("Moisture"  in data) ? data.Moisture  : '' //水分の値が無い場合は空白にする。
      var View_Mood           = ("Mood"      in data) ? data.Mood      : '' //機嫌の値が無い場合は空白にする。
      var FollowUp_source_url = ''                                          //経過登録用
      var FollowUp_image_url  = ("image_url" in data) ? data.image_url : '' //経過登録用画像
      var FollowUp_thum_url   = ("thum_url"  in data) ? data.thum_url  : '' //経過登録用サムネイル画像
      DataImageList.list = []
      DataImageList.UploadList = []

      //食欲について
      switch(View_Appetite) {
        case '◯':
        case 'ok':
        case '普段通り':
          View_Appetite = '◯(普段通り食べれている)'
          break
        case '△':
        case '普段の半分くらい':
          View_Appetite = '△(普段の半分くらい食べれている)'
          break
        case '✕':
        case 'no':
        case '全く食べられない':
          View_Appetite = '✕(全く食べれていない)'
          break
        case '':
        default:
          View_Appetite = ''
          break
      }

      //水分について
      switch(View_Moisture) {
        case '◯':
        case 'ok':
        case '普段通り':
          View_Moisture = '◯(普段通り取れている)'
          break
        case '△':
        case '普段の半分くらい':
          View_Moisture = '△(普段の半分くらい取れている)'
          break
        case '✕':
        case 'no':
        case '全く取れない':
          View_Moisture = '✕(全く取れていない)'
          break
        case '':
        default:
          View_Moisture = ''
          break
      }
      
      //機嫌について
      switch(View_Mood) {
        case '◯':
        case 'ok':
        case '良い':
          View_Mood = '◯(機嫌が良い)'
          break
        case '△':
        case 'やや悪い':
          View_Mood = '△(機嫌がやや悪い)'
          break
        case '✕':
        case 'no':
        case '悪い':
          View_Mood = '✕(機嫌が悪い)'
          break
        case '':
        default:
          View_Mood = ''
          break
      }

      //旧型式の経過画像データに画像登録がある場合は、経過画像リストに読み込む（2021/08/29 追加 高橋）
      if (FollowUp_image_url !== '' && FollowUp_thum_url !== '') {
        //ブラウザ上で一時格納する、画像リストに旧形式で参照データを格納した画像を0番目の画像として格納する
        DataImageList.list.push({
          number:       0,                                                                //画像番号
          source_url:   FollowUp_source_url,                                              //取り込み元画像（旧型式の経過データは空欄として扱う。）
          image_url:    FollowUp_image_url,                                               //経過画像パス
          thum_url:     FollowUp_thum_url,                                                //経過サムネイル画像パス
          CreateTime:   ("CreateTime"   in data) ? data.CreateTime.toDate() : new Date(), //経過情報が初めて記録された時刻
          UpdateTime:   ("UpdateTime"   in data) ? data.UpdateTime.toDate() : new Date(), //経過情報更新時刻
          ShootingTime: ("CreateTime"   in data) ? data.CreateTime.toDate() : new Date(), //経過情報画像作成時刻
          image_change: false,                                                            //経過登録画像の変更有無（true=変更あり、false=変更なし）
        })

        //データベースにアップロードする画像リストに画像を登録する
        DataImageList.UploadList.push({
          image_url:    FollowUp_image_url,                                               //経過画像パス
          thum_url:     FollowUp_thum_url,                                                //経過サムネイル画像パス
          CreateTime:   ("CreateTime"   in data) ? data.CreateTime.toDate() : new Date(), //経過情報が初めて記録された時刻
          UpdateTime:   ("UpdateTime"   in data) ? data.UpdateTime.toDate() : new Date(), //経過情報更新時刻
          ShootingTime: ("CreateTime"   in data) ? data.CreateTime.toDate() : new Date(), //経過情報画像作成時刻
        })
      }
      
      if("images" in data){
        //新形式で保存された画像情報読み込みを行う
        data.images.forEach((image, index)=>{
          
          //旧形式で保存された画像情報を、新形式用画像情報読み込みしないようにする
          if(index !== '0' && FollowUp_image_url !== image.image_url && FollowUp_thum_url !== image.thum_url){
            DataImageList.list.push({
              number:       index,                                                                //画像番号
              source_url:   '',                                                                   //取り込み元画像（旧型式の経過データは空欄として扱う。）
              image_url:    image.image_url,                                                      //経過画像パス
              thum_url:     image.thum_url,                                                       //経過サムネイル画像パス
              CreateTime:   ("CreateTime"   in image) ? image.CreateTime.toDate()   : new Date(), //経過情報が初めて記録された時刻
              UpdateTime:   ("UpdateTime"   in image) ? image.UpdateTime.toDate()   : new Date(), //経過情報更新時刻
              ShootingTime: ("ShootingTime" in image) ? image.ShootingTime.toDate() : new Date(), //経過情報画像撮影時刻
              image_change: false,                                                                //経過登録画像の変更有無（true=変更あり、false=変更なし）
            })
            
            DataImageList.UploadList.push({
              image_url:    image.image_url,                                                      //経過画像パス
              thum_url:     image.thum_url,                                                       //経過サムネイル画像パス
              CreateTime:   ("CreateTime"   in image) ? image.CreateTime.toDate()   : new Date(), //経過情報が初めて記録された時刻
              UpdateTime:   ("UpdateTime"   in image) ? image.UpdateTime.toDate()   : new Date(), //経過情報更新時刻
              ShootingTime: ("ShootingTime" in image) ? image.ShootingTime.toDate() : new Date(), //経過情報画像撮影時刻
            })
          }
        })
      }
      
      setBodyTemperature     (isFinite(data.BodyTemperature) ? data.BodyTemperature : 0) //体温(経過登録用)
      setAppetite            (("Appetite" in data) ? data.Appetite : '') //食欲(経過登録用)
      setMoisture            (("Moisture" in data) ? data.Moisture : '') //水分(経過登録用)
      setMood                (("Mood"     in data) ? data.Mood     : '') //機嫌(経過登録用)
      setView_Appetite       (View_Appetite) //
      setView_Moisture       (View_Moisture)
      setView_Mood           (View_Mood)
      //setFollowUpNote      ('') //メモ(経過登録用)
      setFollowUp_image_url  (FollowUp_image_url) //経過登録用画像
      setFollowUp_thum_url   (FollowUp_thum_url)  //経過登録用サムネイル画像
      setFollowUp_CreateTime (("CreateTime"   in data) ? data.CreateTime.toDate()   : new Date()) //経過情報が初めて記録された時刻
      setFollowUp_UpdateTIme (("UpdateTime"   in data) ? data.UpdateTime.toDate()   : new Date()) //経過情報更新時刻
      setFollowUpTime        (("FollowUpTime" in data) ? data.FollowUpTime.toDate() : new Date()) //経過情報を設定した時刻
      setdata_image_list     (DataImageList.list)                                                 //propsに経過画像リストを反映する。
    })
  }
  
  // 経過画像変更用「参照」ボタンを押した際の処理
  const handleFollowUpReferenceButton = () => {
    console.log("handleFollowUpReferenceButton()")
    var btn_input_file = document.getElementById("file_affectedPartImage");
    btn_input_file.click();
  }

  //経過記録画像変更時の処理
  const handleFollowUpImageFileChange = async(e) => {
    console.log('handleFollowUpImageFileChange()')
    var createObjectURL = (window.URL || window.webkitURL).createObjectURL || window.createObjectURL;
    var files = e.target.files
    var fileCount = files.length //読み込んだファイル数
    var num = DataImageList.list.length
    for (var i = 0; i < fileCount; i++ ) {
      var source_url     = createObjectURL(files[i])
      var image_url      = await resizeImage(files[i])
      var image_thum_url = await resizeThumbnailImage(files[i])
      
      DataImageList.list.push({
        number:       (num + i),                       //画像番号
        source_url:   source_url,                      //取り込み元画像
        image_url:    image_url,                       //経過画像パス
        thum_url:     image_thum_url,                  //経過サムネイル画像パス
        CreateTime:   new Date(),                      //経過情報が初めて記録された時刻
        UpdateTime:   new Date(),                      //経過情報更新時刻
        ShootingTime: new Date(files[i].lastModified), //経過画像撮影日時
        image_change: true,                            //経過登録画像の変更有無（true=変更あり、false=変更なし）
      })

      DataImageList.UploadList.push({
        image_url:    image_url,                       //経過画像パス
        thum_url:     image_thum_url,                  //経過サムネイル画像パス
        CreateTime:   new Date(),                      //経過情報が初めて記録された時刻
        UpdateTime:   new Date(),                      //経過情報更新時刻
        ShootingTime: new Date(files[i].lastModified), //経過画像撮影日時
      })
      console.dir(DataImageList.list)
      console.dir(DataImageList.UploadList)
    }

      //setFollowUp_image_url(image_url)     // 経過画像をブラウザメモリ上で参照するオブジェクトURLで取得する。
      setFollowUp_image_url('')              // 経過画像をブラウザメモリ上で参照するオブジェクトURLで取得する。javascriptのセキュリティエラー対策で参照URLを登録しない
      setFollowUp_image_change(true)         // 経過登録画像の変更有りとして記録する。
      setFollowUpImageBox_width(320)         // 経過画像表示領域の横幅を320pxで設定する。
      setFollowUpImageBox_height(320)        // 経過画像表示領域の高さを320pxで設定する。
      setdata_image_list(DataImageList.list.slice(0, DataImageList.list.length)) // propsに経過画像リストを反映する。
  }

  //画像リサイズ処理（サムネイル画像）
  const resizeThumbnailImage = (file) => new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,                       //画像ファイルのパス
      resizer.maxThumbnailWidth,  //変換後サムネイル画像の最大横幅
      resizer.maxThumbnailHeight, //変換後サムネイル画像の最大縦幅
      resizer.compressFormat,     //圧縮フォーマット（JPEG, PNG or WEBP）
      resizer.quality,            //画質（0 ~ 100 圧縮しない場合は100をセットする。）
      0,                          //画像の回転度数（0,90,180,270,360）
      (uri) => {resolve(uri)},    //responseUriFunc
      resizer.outputType,         //出力タイプ（base64, bolb, file）
    )
  })

  //画像リサイズ処理
  const resizeImage = (file) => new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,                       //画像ファイルのパス
      resizer.maxWidth,           //変換後サムネイル画像の最大横幅
      resizer.maxHeight,          //変換後サムネイル画像の最大縦幅
      resizer.compressFormat,     //圧縮フォーマット（JPEG, PNG or WEBP）
      resizer.quality,            //画質（0 ~ 100 圧縮しない場合は100をセットする。）
      0,                          //画像の回転度数（0,90,180,270,360）
      (uri) => {resolve(uri)},    //responseUriFunc
      resizer.outputType,         //出力タイプ（base64, bolb, file）
    )
  })

  //経過画像登録処理
  const RegistFollowUpImage= async(doc_id, MedicalRecord_ID_) => {
    console.log('RegistFollowUpImage() doc_id:' + doc_id)
    console.log('RegistFollowUpImage() MedicalRecord_ID_:' + MedicalRecord_ID_)
    if(FollowUp_image_change === true){
      //DataImageList.list.forEach((images)=>{
      console.log("FollowUp_image_change === true")
      console.dir(DataImageList.list)
      console.dir(DataImageList.UploadList)
      await Promise.all(DataImageList.list.map(async(images)=>{
      //for (const images of DataImageList.list) {
        console.dir(images)
        var ShootingTime = `${images.ShootingTime.getFullYear()}/${('0' + (images.ShootingTime.getMonth() + 1)).slice(-2)}/${('0' + images.ShootingTime.getDate()).slice(-2)} ` +
                          ` ${('0' + images.ShootingTime.getHours()).slice(-2)}:${('0' + images.ShootingTime.getMinutes()).slice(-2)}:${('0' + images.ShootingTime.getSeconds()).slice(-2)}`
        //サムネイル画像アップロード
        if(images.thum_url.includes('data:image/jpeg;base64,') && images.image_url.includes('data:image/jpeg;base64,')){ //base64形式フォーマットとなっていることを確認する
          var thum_data        = images.thum_url
          var data             = images.image_url
          var thum_fileName    = images.number + "-thum.jpg"                                                        // サムネイル画像のファイル名を設定
          var fileName         = images.number + ".jpg"                                                             // 画像のファイル名を設定
          var storageRef       = firebase.storage().ref('member_data_image')                                        // Storageの参照先ディレクトリを「member_data_image」に設定する。
          var thum_ImagesRef   = storageRef.child(MedicalRecord_ID_ + '/' + doc_id + '/' + thum_fileName) // サムネイル画像のStorageの参照先ファイル名を設定する。
          var ImagesRef        = storageRef.child(MedicalRecord_ID_ + '/' + doc_id + '/' + fileName)      // 画像のStorageの参照先ファイル名を設定する。
          var update_thum_url  = ''                                                                                 // サムネイル画像のStorageアクセス用URLを格納する
          var update_image_url = ''                                                                                 // 画像のStorageアクセス用URLを格納する
          
          // サムネイル画像をfirebase Storageに保存する。
          // Data stringからアップロードする。
          await thum_ImagesRef.putString(thum_data, 'data_url', {
            contentType: 'image/jpeg',
            customMetadata: {
              ShootingTime: ShootingTime
            }
          }).catch(function(er){
            console.log("image upload error", er)
          })
          
          // 画像をfirebase Storageに保存する。
          // Data stringからアップロードする。
          await ImagesRef.putString(data, 'data_url', {
            contentType: 'image/jpeg',
            customMetadata: {
              ShootingTime: ShootingTime
            }
          }).catch(function(er){
            console.log("image upload error", er)
          })
          
          // firebase Storageへ保存したサムネイル画像への参照URLを取得
          await firebase.storage().ref('member_data_image').child(MedicalRecord_ID_ + '/' + doc_id + '/' + thum_fileName)
          .getDownloadURL().then((url)=>{
            update_thum_url = url
            DataImageList.list[images.number].thum_url       = update_thum_url
            DataImageList.UploadList[images.number].thum_url = update_thum_url
          })
          
          // firebase Storageへ保存した画像への参照URLを取得
          await firebase.storage().ref('member_data_image').child(MedicalRecord_ID_ + '/' + doc_id + '/' + fileName)
          .getDownloadURL().then((url)=>{
            update_image_url = url
            DataImageList.list[images.number].image_url       = update_image_url
            DataImageList.UploadList[images.number].image_url = update_image_url
          })
        }
      }))
    }
    console.log('RegistFollowUpImage() doc_id:' + doc_id + ', MedicalRecord_ID: ' + MedicalRecord_ID_ + ' finish !')
  }

  // 経過記録画像読み込み処理
  //loadFollowUpImage(src){
  //  return new Promise((resolve, reject) => {
  //    const img = new Image()
  //    img.onload =() => resolve(img)
  //    img.onerror = (e) => reject(e)
  //    img.src = src
  //  })
  //}

  //経過情報登録
  const RegistFollowUp = async(MedicalRecord_ID_, CreateTime_, UpdateTime_) => {
    console.log("RegistFollowUp() start!!")
    var db = firebase.firestore()

    //作製するドキュメント名（登録時刻）を準備する。
    var create_time = CreateTime_
    var datas_ID = create_time.getFullYear() + ('0' + (create_time.getMonth()+1)).slice(-2) + ('0' + create_time.getDate()).slice(-2) + 
                    ('0' + create_time.getHours()).slice(-2) + ('0' + create_time.getMinutes()).slice(-2) + ('0' + create_time.getSeconds()).slice(-2);
    console.log('create_time:' + create_time)
    console.log('datas_ID:' + datas_ID)
    var first_FollowUp = ''

    let FollowUp_CreateTime_ = CreateTime_
    let FollowUp_UpdateTime_ = UpdateTime_
    let FollowUpTime_ = CreateTime_

    setFollowUp_CreateTime(FollowUp_CreateTime_) //経過情報が初めて記録された時刻
    setFollowUp_UpdateTIme(FollowUp_UpdateTime_) //経過情報更新時刻
    setFollowUpTime(FollowUpTime_) //経過情報を設定した時刻
    //新規受診時の場合のみ登録する
    if ( Interview_state === 'New' ){
      console.log("Interview_state: new")
      console.log("BodyTemperature: " + Number(BodyTemperature))
      console.log("Appetite: " + Appetite)
      console.log("Moisture: " + Moisture)
      console.log("Mood: " + Mood)
      console.log("Note: " + Note)
      console.log("FollowUpTime: " + FollowUpTime_)
      console.log("UpdateTime: " + FollowUp_UpdateTime_)
      console.log("CreateTime: " + FollowUp_CreateTime_)
      console.log("images: " + DataImageList.UploadList)
      console.log("MedicalRecord_ID: " + MedicalRecord_ID_)
      await db.collection("MedicalRecords").doc(MedicalRecord_ID_).collection("datas").doc(datas_ID).set({
        BodyTemperature: Number(BodyTemperature),  //体温（数値型）
        Appetite:        Appetite,                 //食欲
        Moisture:        Moisture,                 //水分
        Mood:            Mood,                     //機嫌
        Note:            FollowUpNote,             //メモ
        FollowUpTime:    FollowUpTime_,            //経過記録時刻
        UpdateTime:      UpdateTime_,              //更新時刻
        CreateTime:      CreateTime_,              //作製時刻
        images:          DataImageList.UploadList, //登録画像リスト
        //thum_url:        FollowUp_thum_url,        //経過記録サムネイル画像
        //image_url:       FollowUp_image_url,       //経過記録画像URL
      })

      //初回経過情報登録先のドキュメントパスをstateに格納する。
      setFirst_FollowUp('MedicalRecords/' + MedicalRecord_ID_ + '/datas/' + datas_ID)
      first_FollowUp = 'MedicalRecords/' + MedicalRecord_ID_ + '/datas/' + datas_ID

      console.log('First_FollowUp: ' + First_FollowUp)
      console.log('first_FollowUp: ' + first_FollowUp)


      //初回経過情報登録先を医療情報のドキュメントに追記する。
      await db.collection("MedicalRecords").doc(MedicalRecord_ID_).update({
        First_FollowUp: firebase.firestore().doc(first_FollowUp),
      })
    }
    console.log("RegistFollowUp() MedicalRecord_ID_:" + MedicalRecord_ID_ + ", datas_ID: " + datas_ID + "finish!!")
  }

  //問診票の入力データをデータベースに新規登録する。
  const RegistInterview = async(CreateTime_, UpdateTime_) => {
    console.log("RegistInterview() start!!")
    var db = firebase.firestore()

    //作成するドキュメント名（メンバーID + 作成時刻）を準備する。
    var create_time = CreateTime_;
    var MedicalRecord_ID_ = MemberID + '_' + 
                           create_time.getFullYear() + ('0' + (create_time.getMonth()+1)).slice(-2) + ('0' + create_time.getDate()).slice(-2) + 
                           ('0' + create_time.getHours()).slice(-2) + ('0' + create_time.getMinutes()).slice(-2) + ('0' + create_time.getSeconds()).slice(-2);

    //問診票登録時に診療情報一覧に表示するタイトルを準備する。
    var MedicalRecordTitle = '';
    if ( Fever_Symptoms        === true ) { MedicalRecordTitle = MedicalRecordTitle + '発熱 ' }
    if ( RunnyNose_Symptoms    === true ) { MedicalRecordTitle = MedicalRecordTitle + '鼻水 ' }
    if ( Cough_Symptoms        === true ) { MedicalRecordTitle = MedicalRecordTitle + '咳 ' }
    if ( Headache_Symptoms     === true ) { MedicalRecordTitle = MedicalRecordTitle + '頭痛 ' }
    if ( Phlegm_Symptoms       === true ) { MedicalRecordTitle = MedicalRecordTitle + '痰 ' }
    if ( Wheeze_Symptoms       === true ) { MedicalRecordTitle = MedicalRecordTitle + 'ゼーゼー息 ' }
    if ( Vomit_Symptoms        === true ) { MedicalRecordTitle = MedicalRecordTitle + '嘔吐 ' }
    if ( Diarrhea_Symptoms     === true ) { MedicalRecordTitle = MedicalRecordTitle + '下痢 ' }
    if ( Stommachache_Symptoms === true ) { MedicalRecordTitle = MedicalRecordTitle + '腹痛 ' }
    if ( Eruption_Symptoms     === true ) { MedicalRecordTitle = MedicalRecordTitle + '発疹 ' }
    if ( Spasm_Symptoms        === true ) { MedicalRecordTitle = MedicalRecordTitle + 'けいれん ' }
    
    //診断結果が入力済み、もしくは受診理由のみ入力されている場合はその内容をタイトルに採用する。
    if (Diagnosis !== '') {
      MedicalRecordTitle = Diagnosis
    } else if (Reason_for_Consultation !== '') {
      MedicalRecordTitle = Reason_for_Consultation
    }

    //新規受診時の場合のみ登録する。
    if ( Interview_state === 'New' ){
      await db.collection("MedicalRecords").doc(MedicalRecord_ID_).set({
        FamilyID:                FamilyID,                //診療情報登録対象の家族ID
        MemberID:                MemberID,                //診療情報登録対象のメンバーID
        CreateTime:              CreateTime_,              //診療情報作成日時
        UpdateTime:              UpdateTime_,              //診療情報更新日時
        ConsultationTime:        ConsultationTime,        //受診日
        MedicalSpecialty:        MedicalSpecialty,        //診療科目
        Title:                   MedicalRecordTitle,                 //診療情報一覧に表示するタイトル
        HospitalName:            HospitalName,            //病院名
        Diagnosis:               '',                                 //診断結果
        Reason_for_Consultation: Reason_for_Consultation, //受診理由
        InterviewSheet:{
          Fever_Symptoms:         Fever_Symptoms,                        //発熱症状の有無
          Fever_Since:            getSinceDate(Fever_Since),        //発熱いつから
          Fever_Degrees:          Fever_Degrees,                         //発熱時の体温
          RunnyNose_Symptoms:     RunnyNose_Symptoms,                    //鼻水の有無
          RunnyNose_Since:        getSinceDate(RunnyNose_Since),    //鼻水いつから
          RunnyNose_Color:        RunnyNose_Color,                       //鼻水の色
          Cough_Symptoms:         Cough_Symptoms,                        //咳の有無
          Cough_Since:            getSinceDate(Cough_Since),        //咳いつから
          Cough_Type:             Cough_Type,                            //咳の種類
          Headache_Symptoms:      Headache_Symptoms,                     //頭痛の有無
          Headache_Since:         getSinceDate(Headache_Since),     //頭痛いつから
          Phlegm_Symptoms:        Phlegm_Symptoms,                       //痰の有無
          Phlegm_Since:           getSinceDate(Phlegm_Since),       //痰いつから
          Wheeze_Symptoms:        Wheeze_Symptoms,                       //喘鳴の有無
          Wheeze_Since:           getSinceDate(Wheeze_Since),       //喘鳴いつから
          Vomit_Symptoms:         Vomit_Symptoms,                        //嘔吐の有無
          Vomit_Since:            getSinceDate(Vomit_Since),        //嘔吐いつから
          Vomit_times_per_day:    Vomit_times_per_day,                   //1日の嘔吐回数
          Diarrhea_Symptoms:      Diarrhea_Symptoms,                     //下痢の有無
          Diarrhea_Since:         getSinceDate(Diarrhea_Since),     //下痢いつから
          Diarrhea_times_per_day: Diarrhea_times_per_day,                //1日の下痢回数
          Stommachache_Symptoms:  Stommachache_Symptoms,                 //腹痛の有無
          Stommachache_Since:     getSinceDate(Stommachache_Since), //腹痛いつから
          Eruption_Symptoms:      Eruption_Symptoms,                     //発疹の有無
          Eruption_Since:         getSinceDate(Eruption_Since),     //発疹いつから
          Spasm_Symptoms:         Spasm_Symptoms,                        //けいれんの有無
          Spasm_Since:            getSinceDate(Spasm_Since),        //けいれん いつから
          Note:                   Note                                   //フリーメモ
        }
      })
      setMedicalRecord_ID(MedicalRecord_ID_) //MedicalRecord_IDをstateで保持する。
      console.log('MedicalRecord_ID: ' + MedicalRecord_ID)
      console.log('MedicalRecord_ID_: ' + MedicalRecord_ID_)
    }
    return MedicalRecord_ID_
  }

  //データベースに診療情報を保存する。（更新）
  const UpdateInterView = async() => {
    console.log("UpdateInterview() start!!")
    var db = firebase.firestore()

    //問診票編集モードの場合
    if(Interview_state === 'Edit'){
      var MedicalRecordTitle = '';
      //診断結果及び受診理由が未入力の場合は、入力した症状をタイトルにする。
      if(Diagnosis === '' && Reason_for_Consultation === ''){
        //問診票更新時に診療情報一覧に表示するタイトルを準備する。
        if ( Fever_Symptoms        === true ) { MedicalRecordTitle = MedicalRecordTitle + '発熱 ' }
        if ( RunnyNose_Symptoms    === true ) { MedicalRecordTitle = MedicalRecordTitle + '鼻水 ' }
        if ( Cough_Symptoms        === true ) { MedicalRecordTitle = MedicalRecordTitle + '咳 ' }
        if ( Headache_Symptoms     === true ) { MedicalRecordTitle = MedicalRecordTitle + '頭痛 ' }
        if ( Phlegm_Symptoms       === true ) { MedicalRecordTitle = MedicalRecordTitle + '痰 ' }
        if ( Wheeze_Symptoms       === true ) { MedicalRecordTitle = MedicalRecordTitle + '呼吸音異常 ' }
        if ( Vomit_Symptoms        === true ) { MedicalRecordTitle = MedicalRecordTitle + '嘔吐 ' }
        if ( Diarrhea_Symptoms     === true ) { MedicalRecordTitle = MedicalRecordTitle + '下痢 ' }
        if ( Stommachache_Symptoms === true ) { MedicalRecordTitle = MedicalRecordTitle + '腹痛 ' }
        if ( Eruption_Symptoms     === true ) { MedicalRecordTitle = MedicalRecordTitle + '発疹 ' }
        if ( Spasm_Symptoms        === true ) { MedicalRecordTitle = MedicalRecordTitle + 'けいれん ' }
      } else if(Diagnosis !== '') {
        //診断結果が入力済みの場合は、診断結果をタイトルとする。
        MedicalRecordTitle = Diagnosis
      } else if(Reason_for_Consultation !== ''){
        //診断結果が登録されておらず、受診理由のみ登録されている場合は、受診理由をタイトルにする
        MedicalRecordTitle = Reason_for_Consultation
      }
      //console.log('Fever_Since: ' + Fever_Since)

      await db.collection("MedicalRecords").doc(MedicalRecord_ID).update({
        FamilyID:                FamilyID,                //診療情報登録対象の家族ID
        MemberID:                MemberID,                //診療情報登録対象のメンバーID
        CreateTime:              CreateTime,              //診療情報作成日時
        UpdateTime:              new Date(),              //診療情報更新日時
        ConsultationTime:        ConsultationTime,        //受診日
        MedicalSpecialty:        MedicalSpecialty,        //診療科目
        Title:                   MedicalRecordTitle,      //診療情報一覧に表示するタイトル
        HospitalName:            HospitalName,            //病院名
        Diagnosis:               Diagnosis,               //診断結果
        Reason_for_Consultation: Reason_for_Consultation, //受診理由
        First_FollowUp:          firebase.firestore().doc(First_FollowUp_), //初回経過情報参照先パス
        InterviewSheet:{
          Fever_Symptoms:         Fever_Symptoms,                   //発熱症状の有無
          Fever_Since:            getSinceDate(Fever_Since),        //発熱いつから
          Fever_Degrees:          Fever_Degrees,                    //発熱時の体温
          RunnyNose_Symptoms:     RunnyNose_Symptoms,               //鼻水の有無
          RunnyNose_Since:        getSinceDate(RunnyNose_Since),    //鼻水いつから
          RunnyNose_Color:        RunnyNose_Color,                  //鼻水の色
          Cough_Symptoms:         Cough_Symptoms,                   //咳の有無
          Cough_Since:            getSinceDate(Cough_Since),        //咳いつから
          Cough_Type:             Cough_Type,                       //咳の種類
          Headache_Symptoms:      Headache_Symptoms,                //頭痛の有無
          Headache_Since:         getSinceDate(Headache_Since),     //頭痛いつから
          Phlegm_Symptoms:        Phlegm_Symptoms,                  //痰の有無
          Phlegm_Since:           getSinceDate(Phlegm_Since),       //痰いつから
          Wheeze_Symptoms:        Wheeze_Symptoms,                  //喘鳴の有無
          Wheeze_Since:           getSinceDate(Wheeze_Since),       //喘鳴いつから
          Vomit_Symptoms:         Vomit_Symptoms,                   //嘔吐の有無
          Vomit_Since:            getSinceDate(Vomit_Since),        //嘔吐いつから
          Vomit_times_per_day:    Vomit_times_per_day,              //1日の嘔吐回数
          Diarrhea_Symptoms:      Diarrhea_Symptoms,                //下痢の有無
          Diarrhea_Since:         getSinceDate(Diarrhea_Since),     //下痢いつから
          Diarrhea_times_per_day: Diarrhea_times_per_day,           //1日の下痢回数
          Stommachache_Symptoms:  Stommachache_Symptoms,            //腹痛の有無
          Stommachache_Since:     getSinceDate(Stommachache_Since), //腹痛いつから
          Eruption_Symptoms:      Eruption_Symptoms,                //発疹の有無
          Eruption_Since:         getSinceDate(Eruption_Since),     //発疹いつから
          Spasm_Symptoms:         Spasm_Symptoms,                   //けいれんの有無
          Spasm_Since:            getSinceDate(Spasm_Since),        //けいれん いつから
          Note:                   Note                              //フリーメモ
        }
      })
    }
  }

  //経過情報更新
  const UpdateFollowUp = async() => {
    console.log("UpdateFollowUp() start!!")
    var db = firebase.firestore()

    //編集モードの場合のみ更新する
    if (Interview_state === 'Edit' && First_FollowUp_ !== ''){
      await db.doc(First_FollowUp_).update({
        BodyTemperature: Number(BodyTemperature),  //体温（数値型）
        Appetite:        Appetite,                 //食欲
        Moisture:        Moisture,                 //水分
        Mood:            Mood,                     //機嫌
        Note:            FollowUpNote,             //メモ
        FollowUpTime:    FollowUpTime,             //経過記録時刻
        UpdateTime:      FollowUp_UpdateTIme,      //更新時刻
        CreateTime:      FollowUp_CreateTime,      //作製時刻
        images:          DataImageList.UploadList, //登録画像リスト
        //thum_url:        FollowUp_thum_url,       //経過記録サムネイル画像
        //image_url:       FollowUp_image_url,      //経過記録画像URL
      })
    }
  }

  useEffect(() => { //ページ表示時、情報更新時に実行
    // componentDidMount のタイミングで実行したい処理を記述
    //問診票新規登録モードの場合
    if(Interview_state === 'New'){
      console.log("Interview_state = " + Interview_state)
      setEditShow('block')    //問診票 新規登録＋編集共通表示【表示】
      setNewOnlyShow('block') //問診票 新規登録画面　　　　　【表示】
      setEditOnlyShow('none') //問診票 編集画面　　　　　　　【非表示】
      setViewShow('none')     //問診票 表示画面　　　　　　　【非表示】
    }

    //問診票表示モードの場合
    if(Interview_state === 'View'){
      console.log("Interview_state = " + Interview_state)
      setEditShow('none')     //問診票 新規登録＋編集共通表示【非表示】
      setNewOnlyShow('none')  //問診票 新規登録画面　　　　　【非表示】
      setEditOnlyShow('none') //問診票 編集画面　　　　　　　【非表示】
      setViewShow('block')    //問診票 表示画面　　　　　　　【表示】
      Promise.resolve().then(()=>{
        return new Promise(async(resolve)=>{
          await ReadInterview()     //データベースから登録済みの問診票データを読み出す。
          resolve()
        })
      })
      .then(()=>{
        return new Promise(async(resolve)=>{
          // console.log('first_FollowUp: ' + First_FollowUp)
          console.log('first_FollowUp: ' + First_FollowUp_)
          // if(First_FollowUp !== ''){
          if(First_FollowUp_ !== ''){
            //初回経過情報が登録されている場合は読み出す。
            await ReadFollowUp()    //データベースから登録済みの初回経過情報を読み出す。
          }
          resolve()
        })
      })
    }

    //問診票編集モードの場合
    if(Interview_state === 'Edit'){
      console.log("Interview_state = " + Interview_state)
      setEditShow('block')     //問診票 新規登録＋編集共通表示【表示】
      setNewOnlyShow('none')   //問診票 新規登録画面　　　　　【非表示】
      setEditOnlyShow('block') //問診票 編集画面　　　　　　　【表示】
      setViewShow('none')      //問診票 表示画面　　　　　　　【非表示】
      Promise.resolve().then(()=>{
        return new Promise(async(resolve)=>{
          await ReadInterview()     //データベースから登録済みの問診票データを読み出す。
          resolve()
        })
      })
      .then(()=>{
        return new Promise(async(resolve)=>{
          // console.log('first_FollowUp: ' + First_FollowUp)
          console.log('first_FollowUp: ' + First_FollowUp_)
          // if(First_FollowUp !== ''){
          if(First_FollowUp_ !== ''){
            //初回経過情報が登録されている場合は読み出す。
            await ReadFollowUp()    //データベースから登録済みの初回経過情報を読み出す。
            if(FollowUp_image_url !== ''){
              //初回経過画像が登録されている場合は描画する。
              setFollowUpImageBox_width(320) // 経過画像表示領域の横幅を320pxで設定する。
              setFollowUpImageBox_height(320) // 経過画像表示領域の高さを320pxで設定する。
            }
          }
          resolve()
        })
      })
    }
    // 次の行のコメントでeslintの余分なワーニングを抑制する。
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setInterview_state, setMedicalRecord_ID, setdata_image_list]);

  //問診票登録日時表示用
  let CreateTime_           = CreateTime
  let interview_CreateTime2 = `${CreateTime_.getFullYear()}/${('0' + (CreateTime_.getMonth() + 1)).slice(-2)}/${('0' + CreateTime_.getDate()).slice(-2)} ` +
                                ` (${["日", "月", "火", "水", "木", "金", "土"][CreateTime_.getDay()]}) ${('0' + CreateTime_.getHours()).slice(-2)}:${('0' + CreateTime_.getMinutes()).slice(-2)}`

  let ConsultationTime_      = ConsultationTime  //受診日時
  let ConsultationTime2     = `${ConsultationTime_.getFullYear()}-${('0' + (ConsultationTime_.getMonth() + 1)).slice(-2)}-${('0' + ConsultationTime_.getDate()).slice(-2)}T${('0' + ConsultationTime_.getHours()).slice(-2)}:${('0' + ConsultationTime_.getMinutes()).slice(-2)}`
  //症状いつからのリスト
  /*
  const Since_List = [];
  Since_List.push(<MenuItem key='0' value=''>　</MenuItem>)
  Since_List.push(<MenuItem key='1' value='今日から'>今日から</MenuItem>)
  Since_List.push(<MenuItem key='2' value='昨日から'>昨日から</MenuItem>)
  Since_List.push(<MenuItem key='3' value='２、３日前から'>２、３日前から</MenuItem>)
  Since_List.push(<MenuItem key='4' value='４、５日前から'>４、５日前から</MenuItem>)
  Since_List.push(<MenuItem key='5' value='１週間前から'>１週間前から</MenuItem>)
  Since_List.push(<MenuItem key='6' value='２週間前から'>２週間前から</MenuItem>)
  Since_List.push(<MenuItem key='7' value='１カ月前から'>１カ月前から</MenuItem>)
  Since_List.push(<MenuItem key='8' value='もっと前から'>もっと前から</MenuItem>)
  */

  //発熱時の体温の選択肢
  const FeverDegreesList = [];
  FeverDegreesList.push(<MenuItem key='0.0' value='0.0'>　</MenuItem>)
  for(let temp = Number(35.5).toFixed(1); temp <= 42.0; temp = Number(Number(temp) + 0.1).toFixed(1)){ //通常時の体温を記録する為、35.5℃から
    FeverDegreesList.push(<MenuItem key={temp} value={temp}>{temp}</MenuItem>)
  }

  //鼻水の色の選択肢
  const RunnyNoseColorList = [];
  RunnyNoseColorList.push(<MenuItem key='0' value=''>　</MenuItem>)
  RunnyNoseColorList.push(<MenuItem key='1' value='水っぱな'>水っぱな</MenuItem>)
  RunnyNoseColorList.push(<MenuItem key='2' value='黄色'>黄色</MenuItem>)
  RunnyNoseColorList.push(<MenuItem key='3' value='青っぱな'>青っぱな</MenuItem>)
  
  //咳の種類
  const CoughTypeList = []
  CoughTypeList.push(<MenuItem key='0' value=''>　</MenuItem>)
  CoughTypeList.push(<MenuItem key='1' value='コンコン'>コンコン</MenuItem>)
  CoughTypeList.push(<MenuItem key='2' value='ゲホゲホ'>ゲホゲホ</MenuItem>)
  CoughTypeList.push(<MenuItem key='3' value='ケンケン'>ケンケン</MenuItem>)

  //1日の嘔吐の回数の選択肢
  const VomitTimesList = [];
  VomitTimesList.push(<MenuItem key={0} value={0}>　</MenuItem>)
  for(let i=1; i<=10; i++ ){
    VomitTimesList.push(<MenuItem key={i} value={i}>{i}</MenuItem>)
  }

  //1日の下痢の回数の選択肢
  const DiarrheaTimesList = [];
  DiarrheaTimesList.push(<MenuItem key={0} value={0}>　</MenuItem>)
  for(let i=1; i<=10; i++ ){
    DiarrheaTimesList.push(<MenuItem key={i} value={i}>{i}</MenuItem>)
  }

  //食欲（経過登録用）の選択肢
  const AppetiteList = []
  AppetiteList.push(<MenuItem key='0' value=''>　</MenuItem>)
  AppetiteList.push(<MenuItem key='1' value='◯'>◯(普段通り食べれている)</MenuItem>)
  AppetiteList.push(<MenuItem key='2' value='△'>△(普段の半分くらい食べれている)</MenuItem>)
  AppetiteList.push(<MenuItem key='3' value='✕'>✕(全く食べれていない)</MenuItem>)

  //水分（経過登録用）の選択肢
  const MoistureList = []
  MoistureList.push(<MenuItem key='0' value=''>　</MenuItem>)
  MoistureList.push(<MenuItem key='1' value='◯'>◯(普段通り取れている)</MenuItem>)
  MoistureList.push(<MenuItem key='2' value='△'>△(普段の半分くらい取れている)</MenuItem>)
  MoistureList.push(<MenuItem key='3' value='✕'>✕(全く取れていない)</MenuItem>)

  //機嫌（経過登録用）の選択肢
  const MoodList = []
  MoodList.push(<MenuItem key='0' value=''>　</MenuItem>)
  MoodList.push(<MenuItem key='1' value='◯'>◯(機嫌が良い)</MenuItem>)
  MoodList.push(<MenuItem key='2' value='△'>△(機嫌がやや悪い)</MenuItem>)
  MoodList.push(<MenuItem key='3' value='✕'>✕(機嫌が悪い)</MenuItem>)

  //経過画像リスト確認用
  // const FollowUpImgView = []
  // data_image_list.forEach((images)=>{
  //   console.log("images.number: " + images.number)
  //   FollowUpImgView.push(
  //     <Grid item xs={12} key={'DataImage_' + images.number}>
  //       <img style={{width: '100%', margin: '5px 0'}} src={images.image_url} alt={images.CreateTime.toLocaleDateString()} />
  //     </Grid>
  //   )
  // })

  return (
    <>
      <Grid container direction="row" justifyContent="flex-start" alignItems="flex-end" spacing={2} style={{padding: '10px'}}>
        <div style={{display: NewOnlyShow}}>
          <Grid item xs={12}> {/* 登録する家族の名前を表示する。 */}
            <Typography variant="h6">
              問診票登録：　{DisplayName}
            </Typography>
          </Grid>
        </div>        {/* 編集時のみの表示 */}
        <div style={{display: EditOnlyShow}}>
          <Grid item xs={12}> {/* 家族の名前を表示する。 */}
            <Typography variant="h6">
              問診票：　{DisplayName}
            </Typography>
          </Grid>
        </div>
      </Grid>
      <Grid container direction="row" justifyContent="flex-start" alignItems="flex-end" spacing={2}>
        {/* 診断結果 */}
        {/* 診断結果は2021/08/13に問診票編集画面で非表示化
        <Grid item xs={12} style={{display: EditOnlyShow}}>
          <TextField id="input_Diagnosis" className="w-100" label="診断結果"
            value={Diagnosis} onChange={(e)=>handleEditDiagnosis(e)} />
        </Grid>
        */}        {/* 受診医療機関 */}
        {/*
        <Grid item xs={12}>
          <TextField id="input_Hospital" className="w-100" label="受診医療機関"
            value={HospitalName} onChange={(e)=>handleEditHospitalName(e)} />
        </Grid>
        */}        {/* 診療科 */}
        {/*
        <Grid item xs={12}>
          <TextField id="input_MedicalSpecialty" className="w-100" label="診療科"
            value={MedicalSpecialty} onChange={(e)=>handleEditMedicalSpecialty(e)} />
        </Grid>
        */}        {/* 問診票登録日時 */}
        <Grid item xs={12}>
          {interview_CreateTime2}
        </Grid>        {/* 受診(予定)日 */}
        <Grid item xs={12} style={{padding: '1em 8px 0px', fontSize: '1.1rem'}}>受診日</Grid>
        <Grid item xs={12}>
          <TextField id="datetime-local" label="受診日" type="datetime-local" value={ConsultationTime2} 
            InputProps={{inputProps: {step: 300,}}} InputLabelProps={{shrink: true,}} onChange={(e)=>handleEditConsultationTime(e)} />
        </Grid>
        {/* 体温の入力 */}
        <Grid item xs={12} style={{padding: '1em 8px 0px', fontSize: '1.1rem'}}>体温を入力しましょう</Grid>
        <Grid item xs={6}>
          <TextField select id="sel_Fever_Degrees" label="体温" className="w-100" value={Number(Fever_Degrees).toFixed(1)}
            onChange={(e)=>handleFeverDegreesChange(e)} InputProps={{startAdornment:<InputAdornment position="start" >℃</InputAdornment>}}>
            {FeverDegreesList}
          </TextField>
        </Grid>
        <Grid item xs={6} />
        {/* 受診理由 */}
        <Grid item xs={12}>
          <TextField id="Reason_for_Consultation" label="受診理由" className="w-100" value={Reason_for_Consultation}
            onChange={(e)=>Edit_Reason_for_Consultation(e)} />
        </Grid>
             {/* 発熱 */}
        <Grid item xs={12} style={{padding: '1em 8px 0px', fontSize: '1.1rem'}}>発熱</Grid>
        {/* 発熱開始時期を選択 */}
        {/*
        <Grid item xs={6} style={{padding: '0px 8px 8px'}}>
          <TextField select id="sel_Fever_Since" label="いつから" style={{marginLeft: '1em', width: 'calc(100% - 1em)'}}
            value={Fever_Since} onChange={(e)=>handleFeverSinceChange(e)}>
            {Since_List}
          </TextField>
        </Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}} />
        */}        <Grid item xs={6} style={{padding: '0px 8px 8px'}}> {/* 発熱開始時期を選択 */}
          <TextField type="date" id="sel_Fever_Since" label="いつから" style={{marginLeft: '1em', width: 'calc(100% - 1em)'}}
            value={Fever_Since} onChange={(e)=>handleFeverSinceChange(e)} InputLabelProps={{shrink: true}} />
        </Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}} />        {/* 鼻水 */}
        <Grid item xs={12} style={{padding: '1.7em 8px 0px', fontSize: '1.1rem'}}>鼻水はありますか？</Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}}> {/* 鼻水開始時期を選択 */}
          <TextField type="date" id="sel_RunnyNose_Since" label="いつから" style={{marginLeft: '1em', width: 'calc(100% - 1em)'}}
            value={RunnyNose_Since} onChange={(e)=>handleRunnyNoseSinceChange(e)} InputLabelProps={{shrink: true}} />
        </Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}}> {/* 鼻水の色 */}
          <TextField select id="sel_RunnyNose_Color" label="種類" className="w-100"
            value={RunnyNose_Color} onChange={(e)=>handleRunnyNoseColorChange(e)}>
            {RunnyNoseColorList}
          </TextField>
        </Grid>        {/* 咳 */}
        <Grid item xs={12} style={{padding: '1.7em 8px 0px', fontSize: '1.1rem'}}>咳はありますか？</Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}}> {/* 咳開始時期を選択 */}
          <TextField type="date" id="sel_Cough_Since" label="いつから" style={{marginLeft: '1em', width: 'calc(100% - 1em)'}}
            value={Cough_Since} onChange={(e)=>handleCoughSinceChange(e)} InputLabelProps={{shrink: true}} />
        </Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}}> {/* 咳の種類 */}
          <TextField select id="sel_Cough_Type" label="種類" className="w-100"
            value={Cough_Type} onChange={(e)=>handleCoughTypeChange(e)}>
            {CoughTypeList}
          </TextField>
        </Grid>        {/* 頭痛 */}
        <Grid item xs={12} style={{padding: '1.7em 8px 0px', fontSize: '1.1rem'}}>頭痛はありますか？</Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}}> {/* 頭痛開始時期を選択 */}
          <TextField type="date" id="sel_Headache_Since" label="いつから" style={{marginLeft: '1em', width: 'calc(100% - 1em)'}}
            value={Headache_Since} onChange={(e)=>handleHeadacheSinceChange(e)} InputLabelProps={{shrink: true}} />
        </Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}} />        {/* 痰 */}
        <Grid item xs={12} style={{padding: '1.7em 8px 0px', fontSize: '1.1rem'}}>痰（たん）は出てますか？</Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}}> {/* 痰開始時期を選択 */}
          <TextField type="date" id="sel_Phlegm_Since" label="いつから" style={{marginLeft: '1em', width: 'calc(100% - 1em)'}}
            value={Phlegm_Since} onChange={(e)=>handlePhlegmSinceChange(e)} InputLabelProps={{shrink: true}} />
        </Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}} /> {/* 痰の種類（透明、黄、茶、緑）を選べるようにする */}        {/* 喘鳴（ゼーゼー息）⇒呼吸音異常 */}
        <Grid item xs={12} style={{padding: '1.7em 8px 0px', fontSize: '1.1rem'}}>呼吸音に異変はありますか？</Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}}> {/* 呼吸音異常の開始時期を選択 */}
          <TextField type="date" id="sel_Wheeze_Since" label="いつから" style={{marginLeft: '1em', width: 'calc(100% - 1em)'}}
            value={Wheeze_Since} onChange={(e)=>handleWheezeSinceChange(e)} InputLabelProps={{shrink: true}} />
        </Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}} />        {/* 嘔吐 */}
        <Grid item xs={12} style={{padding: '1.7em 8px 0px', fontSize: '1.1rem'}}>嘔吐（おうと）はありますか？</Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}}> {/* 嘔吐開始時期を選択 */}
          <TextField type="date" id="sel_Vomit_Since" label="いつから" style={{marginLeft: '1em', width: 'calc(100% - 1em)'}}
            value={Vomit_Since} onChange={(e)=>handleVomitSinceChange(e)} InputLabelProps={{shrink: true}} />
        </Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}}> {/* 1日の嘔吐の回数 */}
          <TextField select id="sel_Vomit_Times" label="1日の回数" className="w-100" 
            value={Vomit_times_per_day} onChange={(e)=>handleVomitTimesChange(e)}
            InputProps={{endAdornment:<InputAdornment position="start" style={{paddingRight: '1em'}}>回</InputAdornment>}}
          >
            {VomitTimesList}
          </TextField>
        </Grid>        {/* 下痢 */}
        <Grid item xs={12} style={{padding: '1.7em 8px 0px', fontSize: '1.1rem'}}>下痢（げり）はありますか？</Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}}> {/* 下痢開始時期を選択 */}
          <TextField type="date" id="sel_Diarrhea_Since" label="いつから" style={{marginLeft: '1em', width: 'calc(100% - 1em)'}}
            value={Diarrhea_Since} onChange={(e)=>handleDiarrheaSinceChange(e)} InputLabelProps={{shrink: true}} />
        </Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}}> {/* 1日の下痢の回数 */}
          <TextField select id="sel_Diarrhea_Times" label="1日の回数" className="w-100" 
            value={Diarrhea_times_per_day} onChange={(e)=>handleDiarrheaTimesChange(e)}
            InputProps={{endAdornment:<InputAdornment position="start" style={{paddingRight: '1em'}}>回</InputAdornment>}}
          >
            {DiarrheaTimesList}
          </TextField>
        </Grid>        {/* 腹痛 */}
        <Grid item xs={12} style={{padding: '1.7em 8px 0px', fontSize: '1.1rem'}}>腹痛はありますか？</Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}}> {/* 腹痛開始時期を選択 */}
          <TextField type="date" id="sel_Stommachache_Since" label="いつから" style={{marginLeft: '1em', width: 'calc(100% - 1em)'}}
            value={Stommachache_Since} onChange={(e)=>handleStommachacheSinceChange(e)} InputLabelProps={{shrink: true}} />
        </Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}} />        {/* 発疹 */}
        <Grid item xs={12} style={{padding: '1.7em 8px 0px', fontSize: '1.1rem'}}>発疹（ほっしん）はありますか？</Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}}> {/* 発疹開始時期を選択 */}
          <TextField type="date" id="sel_Eruption_Since" label="いつから" style={{marginLeft: '1em', width: 'calc(100% - 1em)'}}
            value={Eruption_Since} onChange={(e)=>handleEruptionSinceChange(e)} InputLabelProps={{shrink: true}} />
        </Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}} />        {/* けいれん */}
        <Grid item xs={12} style={{padding: '1.7em 8px 0px', fontSize: '1.1rem'}}>痙攣（けいれん）はありますか？</Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}}> {/* けいれん開始時期を選択 */}
          <TextField type="date" id="sel_Spasm_Since" label="いつから" style={{marginLeft: '1em', width: 'calc(100% - 1em)'}}
            value={Spasm_Since} onChange={(e)=>handleSpasmSinceChange(e)} InputLabelProps={{shrink: true}} />
        </Grid>
        <Grid item xs={6} style={{padding: '0px 8px 8px'}} />        <Grid item xs={12} style={{padding: '1.7em 8px 0px', fontSize: '1rem'}}>食欲・水分摂取・機嫌はいかがでしょうか？</Grid>
        {/* 食欲 */}
        <Grid item xs={4} style={{padding: '0px 8px 8px'}}> {/* 食欲の状態を選択する */}
          <TextField select id="sel_Appetite" label="食欲" className="w-100"
            value={Appetite} onChange={(e)=>handleAppetiteChange(e)}>
              {AppetiteList}
            </TextField>
        </Grid>        {/* 水分 */}
        <Grid item xs={4} style={{padding: '0px 8px 8px'}}> {/* 水分の状態を選択する */}
          <TextField select id="sel_Moisture" label="水分摂取" className="w-100"
            value={Moisture} onChange={(e)=>handleMoistureChange(e)}>
            {MoistureList}
          </TextField>
        </Grid>        {/* 機嫌 */}
        <Grid item xs={4} style={{padding: '0px 8px 8px'}}> {/* 機嫌を選択する */}
          <TextField select id="sel_Mood" label="機嫌" className="w-100"
            value={Mood} onChange={(e)=>handleMoodChange(e)}>
            {MoodList}
          </TextField>
        </Grid>
        {/* 経過画像登録 */}
        <Grid item xs={12}>症状がわかる画像があれば登録しましょう</Grid>
        <div id="FollowUpImg">
          {/* {console.log("data_image_list.length: " + data_image_list.length)} */}
          {/* {console.log("DataImageList.list.length: " + DataImageList.list.length)} */}
          {DataImageList.list.map((images)=>(
            <Grid item xs={12} key={'DataImage_' + images.number}>
              <img style={{width: '100%', margin: '5px 0'}} src={images.image_url} alt={images.CreateTime.toLocaleDateString()} />
            </Grid>
          ))}
        </div>
        <Grid item xs={12} style={{display: 'block'}}>
          {/* 読み込みした経過画像を表示する。 */}
        </Grid>
        <Grid item xs={12}>
          <Button variant="outlined" color="primary" onClick={()=>handleFollowUpReferenceButton()}>
            参照
          </Button>
          <input type="file" multiple id="file_affectedPartImage" accept=".jpg,.jpeg,.png,.webp,.svg" style={{display: 'none'}} onChange={(e)=>handleFollowUpImageFileChange(e)} />
        </Grid>
        {/* フリーメモ */}
        <Grid item xs={12}> {/* 症状などの詳細をメモとして入力する */}
          <TextField id="Free_Note" label="メモ（症状・様子等）" className="w-100"
            value={Note} onChange={(e)=>handleNote(e)} 
            multiline minRows={5} variant="outlined" /> {/* 5行分のスペースを表示領域とする */}
        </Grid>
      </Grid>      <Toolbar />      <Grid container justifyContent="space-between" alignItems="flex-start">
        {/* 新規登録時のみ、「戻る」ボタンを表示する。 */}
        <div style={{display: NewOnlyShow}}>
          <Button variant="outlined" color="primary" onClick={()=>handleModalClose()}>戻る</Button>
        </div>        {/* 編集時のみ、「キャンセル」ボタン（モーダルを閉じ、症状カード画面に戻る）を表示する。 */}
        <div style={{display: EditOnlyShow}}>
          {/* <Button variant="outlined" color="primary" onClick={(=>handleView()}>キャンセル</Button> */}
          <Button variant="outlined" color="primary" onClick={()=>handleModalClose()}>キャンセル</Button>
        </div>
     
        {/* 新規登録時のみ、「登録」ボタンを表示する。 */}
        <div style={{display: NewOnlyShow}}>
          <Button variant="outlined" color="primary" onClick={()=>handleRegist()}>登録</Button>
        </div>        {/* 編集時のみ、「保存」ボタンを表示する。 */}
        <div style={{display: EditOnlyShow}}>
          <Button variant="outlined" color="primary" onClick={()=>handleUpdate()}>保存</Button>
        </div>
      </Grid>
    </>
  )
}
